import React from 'react';
import cn from 'classnames';
import styles from './NavBar.module.sass'
import Image from "../Image";
import featuredIcon from "../../assets/featured.png";
import packagesIcon from "../../assets/packages.png";
import printsIcon from "../../assets/prints.png";

const NavBar = ({ selectedIcon, setSelectedIcon }) => {
  return (
    <div className={styles.navContainer}>
      <div className={styles.innerWrapper}>
        <div className={cn(styles.iconContainer, selectedIcon === 'featured' && styles.selected)}>
          <Image
            src={featuredIcon}
            alt="View featured packages"
            classes={styles.icon}
            onClick={() => setSelectedIcon('featured')}
          />
        </div>
        <div className={cn(styles.iconContainer, selectedIcon === 'packages' && styles.selected)}>
          <Image
            src={packagesIcon}
            alt="View packages"
            classes={styles.icon}
            onClick={() => setSelectedIcon('packages')}
          />
        </div>
        <div className={cn(styles.iconContainer, selectedIcon === 'prints' && styles.selected)}>
          <Image
            src={printsIcon}
            alt="View single prints"
            classes={styles.icon}
            onClick={() => setSelectedIcon('prints')}
          />
        </div>
      </div>
    </div>
  )
}

export default NavBar;
